import type { FC } from 'react';

interface StatCardProps {
    label: string;
    value: string | number;
    accent?: 'emerald' | 'red';
}

const StatCard: FC<StatCardProps> = ({ label, value, accent }) => {
    const valueColor = accent === 'emerald' ? 'text-emerald-700' : accent === 'red' ? 'text-red-600' : 'text-stone-900';
    return (
        <div className="rounded-2xl border border-stone-200 bg-white p-4 shadow-sm">
            <p className="text-xs font-medium text-stone-500">{label}</p>
            <p className={`text-2xl font-semibold mt-1 ${valueColor}`}>{value}</p>
        </div>
    );
};

export default StatCard;